<template>
  <div class="position-relative" style="text-overflow: initial; white-space: initial">
    <div class="position-absolute top-0 end-0">
      <i
        :class="'fa fa-angle-' + (expanded ? 'up' : 'down') + ' text-primary'"
        style="cursor: pointer"
        @click="expanded = !expanded"
      ></i>
    </div>
    <div :style="getStyle()">
      <slot />
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  props: {
    height: { type: String, default: () => '1rem' },
  },
  setup(props) {
    const expanded = ref(false);

    const getStyle = () => {
      return expanded.value
        ? ''
        : 'background:var(--text-primary-color); -webkit-text-fill-color: transparent; -webkit-background-clip: text; height:' +
            props.height; // dirty css hack, removing the text colors as a side effect
    };

    return {
      expanded,
      getStyle,
    };
  },
};
</script>
